function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16.962 9a1 1 0 0 1 1 1v2.997h2.955a1 1 0 0 1 .994.884l.006.116a1 1 0 0 1-1 1h-2.955v2.92a1 1 0 0 1-.883.994l-.117.006a1 1 0 0 1-1-1v-2.92H13a1 1 0 0 1-.993-.883L12 13.997a1 1 0 0 1 1-1h2.962V10a1 1 0 0 1 .884-.993zM9 13a1 1 0 0 1 0 2H3a1 1 0 0 1 0-2zm4-4a1 1 0 0 1 0 2H3a1 1 0 0 1 0-2zm0-4a1 1 0 0 1 0 2H3a1 1 0 1 1 0-2z"
}));

var SvgAddSort = function SvgAddSort(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddSort, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/addSort.1981ad3b.svg";
export { ForwardRef as ReactComponent };